export const iOS = ( navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false );
export const rootURL = window.location.hostname.indexOf('tombrasweb.com') !== -1 ? 'https://selectrucks-dev.azurewebsites.net' : '';
export const mapURL = iOS ? 'http://maps.apple.com/?daddr=' : 'https://www.google.com/maps/?q=';
export const jwpKey = '9GQpho8COv//iXvOVoUsE1iMEt7TBdU648QBPHOyUAoAUYgG';
export const jwpPlayerId = 'QGLA6xKY';